import { AnyAction } from 'redux';
import { fork, takeEvery } from 'redux-saga/effects';
import ApiService from 'services/api';
import CookieService from 'services/cookie';
import { setApiToken } from './slice';

function setApiTokenFlow({ payload: apiToken }: AnyAction) {
  ApiService.setAuth(apiToken);

  if (!apiToken) {
    CookieService.remove('authApiToken');
    return;
  }

  CookieService.set('authApiToken', apiToken);
}

function* setApiTokenFlowWatcher() {
  yield takeEvery(setApiToken.toString(), setApiTokenFlow);
}

export default [fork(setApiTokenFlowWatcher)];
